import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import { SkeletonPlaceholder } from '../Skeleton/SkeletonPlaceholder';
import { HeadingText50, HeadingText60 } from '../Typography/Typography';
export const PageHeader = ({ children }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const TextComponent = smallScreenDetected ? HeadingText50 : HeadingText60;
    return (_jsx(TextComponent, { marginTop: 48, marginBottom: 20, children: children }));
};
export const PageHeaderSkeleton = () => (_jsx(SkeletonPlaceholder, { width: 220, height: 40, marginTop: 46, marginBottom: 24 }));
